import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { ApiDataSource } from '../../utils/api-data-source';
import { AppService } from '../../app.service';
import { ApiRequestService } from '../../shared/api-request.service';
import { UtilsService } from '../../shared/utils.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-toolbox-talks-templates-selector',
  templateUrl: './toolbox-talks-templates-selector.component.html',
  styleUrls: ['./toolbox-talks-templates-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ToolboxTalksTemplatesSelectorComponent implements OnInit {
  // columns to show and the data source
  displayedColumns: string[] = ['select', 'id', 'name', 'date_created'];
  dataSource: ToolboxTalksTemplatesSelectorDataSource;
  returnAllSelected = false;

  // the paginator and sorter
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public app: AppService,
    private api: ApiRequestService,
    public utils: UtilsService,
    public dialogRef: MatDialogRef<ToolboxTalksTemplatesSelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // set multiple if it is not present to false
    if (typeof this.data['multiple'] === 'undefined') {
      this.data['multiple'] = false;
    }

    // construct the datasource
    this.dataSource = new ToolboxTalksTemplatesSelectorDataSource(
      this.app,
      this.api,
      this.data['multiple']
    );

    // set a default selection of nothing if no selected values are passed through
    if (typeof this.data['selected'] === 'undefined') {
      this.data['selected'] = [];
    }

    // loop and select the values
    for (let i = 0; i < this.data['selected'].length; i++) {
      if (this.data['selected'][i]) {
        this.dataSource.selection.select(this.data['selected'][i]);
      }
    }

    this.returnAllSelected = this.data.returnAllSelected;
  }

  ngOnInit() {
    this.dataSource.getData();
  }

  ngAfterViewInit() {
    // Reset the paginator when sorting
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    const _tap = tap(() => {
      this.dataSource.limit = this.paginator.pageSize;
      this.dataSource.offset = this.paginator.pageIndex;
      this.dataSource.order_by = this.sort.active;
      this.dataSource.order = this.sort.direction;

      // Sort UTC columns by their corresponding date columns.
      if (this.sort.active == 'date_created_UTC') {
        this.dataSource.order_by = 'date_created';
      }

      this.dataSource.getData(false);
    });

    // Subscribe to the paginator tap events
    this.paginator.page.pipe(_tap).subscribe();
    this.sort.sortChange.pipe(_tap).subscribe();
  }

  // clears the search bar and performs a search
  onClearSearch() {
    // clear the search field in the datasource
    this.dataSource.search = '';
    // search for records
    this.dataSource.getData(true);
  }

  onClearSelected() {
    this.dataSource.selection.clear();
  }

  onSaveAndClose() {
    if (this.returnAllSelected) {
      return this.dialogRef.close({
        selected: this.dataSource.selection.selected,
        isAllSelected: this.dataSource.isAllSelected()
      });
    }

    let response: number | number[];

    if (this.data['multiple']) {
      response = this.dataSource.selection.selected;
    } else {
      if (this.dataSource.selection.selected.length) {
        response = this.dataSource.selection.selected[0];
      } else {
        response = 0;
      }
    }

    this.dialogRef.close(response);
  }

  onClose() {
    this.dialogRef.close();
  }
}

export class ToolboxTalksTemplatesSelectorDataSource extends ApiDataSource {
  order_by = 'id';
  order = 'desc';
  searchBy = 'name';

  getData(resetOffset: boolean = false) {
    this.makeRequest('v1/toolbox-talks', resetOffset, {
      searchBy: this.searchBy,
      template_type: 'template'
    });
  }
}
